
import React, { useState, useEffect, useCallback, useRef } from 'react';
import "./Style/common.css";
import "./Style/header.css";
import "./Style/MyIncentives.css";
import "./Style/trophy_club.css";
// import trophy_club_0 from './Image/trophy_club/trophy_club_0.png';
import Header from "../../Common/Header";
import Section from "../../Common/Section";
import Loading from "../../Common/Loading";
import CryptoJS from "crypto-js";
const SECRET_ENCRYPTION_KEY = "6GJZIa6J7NZzTdzf4K7Em6y6XiqwT09wqkKkNHaAvjE=";


function decrypt(encryptedBase64: string) {
  try {
    const key = CryptoJS.enc.Base64.parse(SECRET_ENCRYPTION_KEY);
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64),
    });

    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Decryption failed:", error);
    return {};
  }
}

const MyIncentives: React.FC = () => {

  // function getAvatarUrl(avatarTitle: string): string {
  //   const hasExtension = /\.[a-zA-Z0-9]+$/.test(avatarTitle);
  //   const fileName = hasExtension ? avatarTitle : `${avatarTitle}.png`;
  //   return `https://www.elearnoncloud.com/Storage/assets/Avatar/${fileName}`;
  // }
  const [avatars, setAvatars] = useState<any[]>([]);
  const [loadingAvatars, setLoadingAvatars] = useState(true);
  const [
    // errorMsg
    , setErrorMsg] = useState("");
  const [
    // myPoints
    , setMyPoints] = useState<number>(
      Number(sessionStorage.getItem("CurrentPoints")) || 0
    );
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedAvatar, setSelectedAvatar] = useState<any | null>(null);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [showBackToBottom, setShowBackToBottom] = useState(true);
  const scrollContainerRef = useRef<HTMLElement | null>(null);

  // const apiUrl = process.env.REACT_APP_DOCUMENT_LINK || 'http://127.0.0.1:8000/';
  const apiUrl = process.env.REACT_APP_DOCUMENT_LINK ;

  const currentAvatarUrl = sessionStorage.getItem("CurrentAvatar") || "";

  const findScrollContainer = (): HTMLElement => {
    const candidates: (HTMLElement | null)[] = [
      (document.scrollingElement as HTMLElement) || null,
      document.getElementById("contents_math"),
      document.getElementById("main_top_container"),
      document.getElementById("contents_english"),
      document.getElementById("contents_physics"),
      document.getElementById("contents_chemistry"),
      document.getElementById("contents_biology"),
      document.body,
      document.documentElement,
    ];

    for (const el of candidates) {
      if (!el) continue;
      try {
        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;
        if (el.scrollHeight > el.clientHeight && (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay" || overflowY === "visible")) {
          return el;
        }
      } catch (e) {
      }
    }
    return (document.scrollingElement as HTMLElement) || document.documentElement;
  };

  // detect and store the scroll container so click handlers can scroll the same element
  scrollContainerRef.current = findScrollContainer();
  const registeredContainer = scrollContainerRef.current;

  const handleScroll = () => {
    const el = (scrollContainerRef.current || registeredContainer || (document.scrollingElement as HTMLElement) || document.documentElement) as HTMLElement;
    const scrollTop = el.scrollTop;
    const innerH = el.clientHeight || window.innerHeight;
    const scrollHeight = el.scrollHeight;

    const scrollable = Math.max(0, scrollHeight - innerH);
    const TOL = 6;
    const atTop = scrollTop <= TOL;
    const atBottom = scrollTop >= Math.max(0, scrollable - TOL);
    const ratio = scrollable <= 0 ? 0 : scrollTop / scrollable;

    if (atTop) {
      setShowBackToBottom(true);
      setShowBackToTop(false);
      return;
    }

    if (atBottom) {
      setShowBackToTop(true);
      setShowBackToBottom(false);
      return;
    }

    if (ratio < 0.5) {
      setShowBackToBottom(true);
      setShowBackToTop(false);
    } else {
      setShowBackToTop(true);
      setShowBackToBottom(false);
    }
  };
  try {
    if (registeredContainer) {
      registeredContainer.addEventListener("scroll", handleScroll, { passive: true });
    } else {
      window.addEventListener("scroll", handleScroll, { passive: true });
    }
  } catch (e) {
    window.addEventListener("scroll", handleScroll, { passive: true });
  }

  // run once to set initial state
  setTimeout(handleScroll, 0);

  useEffect(() => {
    const fetchAvatars = async () => {
      try {
        setLoadingAvatars(true);
        setErrorMsg("");

        const response = await fetch(`${apiUrl}MyIncentives/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            FamilyCode: sessionStorage.getItem("FamilyCode"),
            SchoolCode: sessionStorage.getItem("SchoolCode"),
            Login: sessionStorage.getItem("Login"),
          }),
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch avatars: ${response.status}`);
        }

        const encryptedData = await response.json();
        const decryptedData = decrypt(encryptedData.data);

        if (!Array.isArray(decryptedData)) {
          console.warn("Unexpected decrypted data format:", decryptedData);
          setAvatars([]);
          return;
        }

        const sorted = [...decryptedData].sort((a, b) => {
          if (a.IsCurrent && !b.IsCurrent) return -1;
          if (!a.IsCurrent && b.IsCurrent) return 1;
          return 0;
        });

        setAvatars(sorted);

        const points = Number(sessionStorage.getItem("CurrentPoints")) || 0;
        setMyPoints(points);

      } catch (err: any) {
        console.error("Error in fetch:", err);
        setErrorMsg(err.message || "Unable to load avatars.");
      } finally {
        setLoadingAvatars(false);
      }
    };

    fetchAvatars();
  }, [apiUrl]);

  const sortedAvatars = [...avatars].sort((a, b) => {
    if (a.IsCurrent) return -1;
    if (b.IsCurrent) return 1;
    return 0;
  });

  const purchaseAvatar = async (avatar: any) => {
    if (!avatar) return;

    setLoadingAvatars(true);

    try {
      const response = await fetch(`${apiUrl}purchase_avatar/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          SchoolCode: sessionStorage.getItem("SchoolCode"),
          FamilyCode: sessionStorage.getItem("FamilyCode"),
          Login: sessionStorage.getItem("Login"),
          AvatarTitle: avatar.AvatarTitle,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        console.error("Purchase avatar API failed:", data.error);
        alert(data.error || "Purchase failed"); // Optional: Add alert for feedback
        return;
      }

      const avatarUrl = avatar.AvatarLink;
      sessionStorage.setItem("CurrentAvatar", avatarUrl);

      setAvatars((prev) =>
        prev.map((a) => ({
          ...a,
          Owned: a.AvatarTitle === avatar.AvatarTitle ? true : a.Owned,
          IsCurrent: a.AvatarTitle === avatar.AvatarTitle,
        }))
      );

      setMyPoints((prevPoints) => {
        const updated = prevPoints - avatar.Points;
        sessionStorage.setItem("CurrentPoints", updated.toString());
        window.dispatchEvent(new Event("pointsUpdated"));
        return updated;
      });

    } catch (err) {
      console.error("Error calling purchase avatar API:", err);
      alert("An error occurred while purchasing the avatar.");
    } finally {
      setLoadingAvatars(false);
      setShowConfirm(false);
      setSelectedAvatar(null);
    }
  };

  const setCurrentAvatar = async (avatar: any) => {
    if (!avatar) return;

    const imageUrl = avatar.AvatarLink;
    sessionStorage.setItem("CurrentAvatar", imageUrl);

    setAvatars((prev) =>
      prev.map((a) => ({
        ...a,
        IsCurrent: a.AvatarTitle === avatar.AvatarTitle,
      }))
    );

    try {
      const response = await fetch(`${apiUrl}set_current_avatar/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          SchoolCode: sessionStorage.getItem("SchoolCode"),
          FamilyCode: sessionStorage.getItem("FamilyCode"),
          Login: sessionStorage.getItem("Login"),
          AvatarTitle: avatar.AvatarTitle,
        }),
      });

      if (!response.ok) {
        const data = await response.json();
        console.error("Set current avatar API failed:", data.error);
      }
    } catch (err) {
      console.error("Error calling set_current_avatar API:", err);
    }
  };

  return (
    <form>

      <div id="avatar_list">
        {showConfirm && selectedAvatar && (
          <div className="mi_avatar_lightbox" style={{ display: "block" }}>
            <p>
              <span className="title_text" style={{ marginBottom: "15px" }}>Confirm Purchase</span>
            </p>
            <br />
            <div
              id="confirm_purchase_avatar_img"
              className="confirm_purchase_avatar_img"
              style={{
                backgroundImage: `url(${selectedAvatar.AvatarLink})`,
              }}
            />
            <p>
              <span className="confirm_purchase_avatar_title">
                {selectedAvatar.AvatarTitle}
              </span>
              <span className="confirm_purchase_avatar_price">
                <span className="confirm_purchase_avatar_price_blue">
                  {selectedAvatar.Points}
                </span>
              </span>
            </p>
            <div className="button_box">
              <div
                id="mi_avatar_lightbox_cancel_btn"
                className="general_btn two_btn_lightbox two_btn_left mi_avatar_lightbox_cancel_btn"
                onClick={() => setShowConfirm(false)}
              >
                <p>Cancel</p>
              </div>
              <div
                id="mi_avatar_lightbox_confirm_btn"
                className="general_btn two_btn_lightbox mi_avatar_lightbox_confirm_btn"
                onClick={() => purchaseAvatar(selectedAvatar)}
                style={{ alignItems: "center" }}
              >
                <p>Confirm</p>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* <a href="/STUDENT/MSR/MyIncentives" className="back-to-bottom" id="back_to_bottom_link">Back to Top</a> */}
      <div id="main_top_container">
        <Header />
        <a
          href="#bottom"
          className="back-to-bottom"
          onClick={(e) => {
            e.preventDefault();
            const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
            try {
              container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
            } catch {
              window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
            }
            setTimeout(() => {
              (container as any).scrollTop = (container as any).scrollHeight;
              (document.body as any).scrollTop = document.body.scrollHeight;
            }, 400);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
              try {
                container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
              } catch {
                window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
              }
              setTimeout(() => {
                (container as any).scrollTop = (container as any).scrollHeight;
                (document.body as any).scrollTop = document.body.scrollHeight;
              }, 400);
            }
          }}
          aria-label="Back to bottom"
          role="button"
          tabIndex={0}
          style={{
            opacity: showBackToBottom ? 1 : 0,
            transform: showBackToBottom ? 'translateY(0)' : 'translateY(8px)',
            display: 'block',
            cursor: 'pointer',
            zIndex: 2147483647,
            pointerEvents: showBackToBottom ? 'auto' : 'none',
            position: 'fixed',
            left: 20,
            bottom: 20,
            transition: 'opacity 240ms ease, transform 240ms ease',


            boxShadow: '0 6px 14px rgba(0,0,0,0.18)'
          }}
        >
          Back to Bottom
        </a>

        <a
          href="#top"
          className="back-to-top"
          onClick={(e) => {
            e.preventDefault();
            const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
            try {
              container.scrollTo({ top: 0, behavior: 'smooth' });
            } catch {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            setTimeout(() => {
              (container as any).scrollTop = 0;
              (document.body as any).scrollTop = 0;
            }, 300);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
              try {
                container.scrollTo({ top: 0, behavior: 'smooth' });
              } catch {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
              setTimeout(() => {
                (container as any).scrollTop = 0;
                (document.body as any).scrollTop = 0;
              }, 300);
            }
          }}
          aria-label="Back to top"
          role="button"
          tabIndex={0}
          style={{
            opacity: showBackToTop ? 1 : 0,
            transform: showBackToTop ? 'translateY(0)' : 'translateY(8px)',
            display: 'block',
            cursor: 'pointer',
            zIndex: 2147483647,
            pointerEvents: showBackToTop ? 'auto' : 'none',
            position: 'fixed',
            right: 20,
            bottom: 20,
            transition: 'opacity 240ms ease, transform 240ms ease',
            boxShadow: '0 6px 14px rgba(0,0,0,0.18)'
          }}
        >
          Back to Top
        </a>
        <Section />

        <div id="mi_banner" className="subject_banner">
          <div id="mi_banner_text_img"></div>
        </div>


        <div id="mi_page_btn_container">
          <div id="mi_page_btn_store" className="mi_page_btn">
            <a id="hlinkStore" href="/STUDENT/MSR/MyStore" >Store</a>
          </div>
          <div id="mi_page_btn_avatars" className="mi_page_btn mi_page_btn_selected">
            <a href="/STUDENT/MSR/MyIncentives" id="hlinkMyIncentives" >Avatars</a>
          </div>
          <div id="mi_page_btn_comp" className="mi_page_btn">
            <a href="/STUDENT/MSR/MyCompsCurrent">Comps</a></div>
          <div id="mi_page_btn_purchase" className="mi_page_btn mi_page_btn_last">
            <a id="hlinkPurchases" href="/STUDENT/MSR/AllPurchases" >Purchases</a></div>
        </div>



        <div id="mi_page_avatars" className="contents section_container mi_page_bg">
          <div id="mi_avatars_container" className="section_div">

            <div className="mi_avatars_container d-flex justify-content-center flex-wrap">
              {loadingAvatars ? (
                <Loading />
              ) : (
                sortedAvatars.map((avatar, index) => (
                  <div
                    key={index}
                    className={`mi_avatar_single_box mi_avatar_single_box_expand ${currentAvatarUrl === avatar.AvatarLink ? "mi_avatar_current" : ""
                      }`}
                  >
                    <img
                      src={
                        avatar?.AvatarLink
                          ? avatar.AvatarLink
                          : "https://www.elearnoncloud.com/Storage/assets/Avatar/reading.png"
                      }
                      alt={avatar?.AvatarTitle || "Avatar"}
                      onError={(e) => {
                        e.currentTarget.src =
                          "https://www.elearnoncloud.com/Storage/assets/Avatar/reading.png";
                      }}
                      className="mi_avatar_single_box_image"
                    />
                    <div className="mi_avatar_single_box_right_container">
                      <p className="mi_avatar_single_box_right_title">
                        <b>{avatar.AvatarTitle.toUpperCase()}</b>
                      </p>
                      <p
                        className="mi_avatar_single_box_right_subtitle"
                        style={{ color: avatar.Owned ? "#2561c3" : "#ed4e00" }}
                      >
                        {avatar.Owned ? "Owned" : `${avatar.Points} Points`}
                      </p>
                      {avatar.Owned ? (
                        avatar.IsCurrent ? (
                          <div
                            className={`mi_avatar_single_box_right_btn mi_avatar_single_box_right_btn_selected disabled`}
                            onClick={(e) => e.preventDefault()}
                          >
                            <p>SELECTED</p>
                          </div>
                        ) : (
                          <div
                            className="mi_avatar_single_box_right_btn mi_avatar_single_box_right_btn_set"
                            onClick={() => setCurrentAvatar(avatar)}
                          >
                            <p>SET AS AVATAR</p>
                          </div>
                        )
                      ) : (
                        <div
                          className={
                            avatar.Affordable
                              ? "mi_avatar_single_box_right_btn"
                              : "mi_avatar_single_box_right_btn mi_avatar_single_box_right_btn_not_enough disabled"
                          }
                          onClick={(e) => {
                            if (!avatar.Affordable) return;
                            e.preventDefault();
                            setSelectedAvatar(avatar);
                            setShowConfirm(true);
                          }}
                        >
                          <p>{avatar.Affordable ? "BUY" : "EARN MORE POINTS"}</p>
                        </div>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
          <div className="subject_middle_gap"></div>
          <div className="subject_middle_gap"></div>
        </div>

      </div>
    </form>
  );
};

export default MyIncentives;